import { useGLTF} from "@react-three/drei";
import { dispose } from '@react-three/fiber'
import React, {useEffect} from "react";
import MaterialInitialiser from "../materials/MaterialInitialiser";
import ModelModuleManager from "../custom-modules/module/ModelModuleManager";
import Initialiser from "../initialiser/Initialiser";
import InitModels from "./initModels";
import PanelsModuleManagerFront from "../custom-modules/panels/PanelsModuleManagerFront";

const ModuleModelLoader = ({modelRef, location, fileFormat, camera}) => {
  
  const link = location + modelRef + fileFormat;
  const gltf = useGLTF(link); 
  useEffect(() => {
    return () => {
      dispose(gltf)
      useGLTF.clear(link) 
    }
  }, [link]) 
  
  const meshData = [];
  const availableModules = [];
  let staticObjects = [];
  
  let protoObject = {};
  let protoObjects = [];
  
  let cloneObject = {};
  let cloneObjects = [];
  
  
  gltf.scene.traverse(function (child) {
    child.castShadow = true;
    child.receiveShadow = true;
    const name = child['name'].split('_');
    
    if (name[0] === 'proto') {
      
      protoObjects.push(protoObject = {
        name: name[1],
        meshSet: child
      });
      
      
    } else if (name[0] === 'clone') {
      
      cloneObjects.push(cloneObject = {
        name: name[1],
        meshSet: child
      });
      
      
    } else if (name[0] === 'component') {
      
      const nodeLeft = child['children'].find(module => module.name.split('-')[0] === 'Node_Left');
      const nodeRight = child['children'].find(module => module.name.split('-')[0] === 'Node_Right');

      
      if (nodeLeft && nodeRight) {
        
        const moduleData = {
          name: name[1],
          nodeLeft: nodeLeft.position.x,
          nodeRight: nodeRight.position.x,
          rotaLeftY: nodeLeft.rotation.y,
          rotaRightY: nodeRight.rotation.y,
          meshSet: child['children']
        }
        availableModules.push(moduleData);
      }
      
      child['children'].forEach((mesh) => {
        meshData.push({
          material: mesh.material,
          name: mesh.name
        });
      });
      
    } else if (name[0] === 'static') {
      staticObjects = child['children'];
    }
    
  });
  
  
  return (
    <>
      <InitModels protoObjects={protoObjects} cloneObjects={cloneObjects} staticObjects={staticObjects}
                  geometriesData={{meshData, availableModules}} camera={camera} object={gltf.scene}/>
      
      <MaterialInitialiser geometries={meshData}/>
      <Initialiser/>
    </>
  )
};

export default ModuleModelLoader;



